<template>
  <div>
    <el-row id="coderRow" v-show="grouping === '1'">
      <el-col :span="24">
        <div id="coderChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="coderTrendingRow" v-show="grouping === '19'">
      <el-col :span="24">
        <div id="coderTrendingChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="cdiStaffRow" v-show="grouping === '2'">
      <el-col :span="24">
        <div id="cdiStaffChart" v-show="!noReviewDashboardData" style=" margin: 0 auto"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="drgRow" v-show="grouping === '3'">
      <el-col :span="24">
        <div id="drgChart" v-show="!noReviewDashboardData" style=" margin: 0 auto; height: 100%;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="patTypeRow" v-show="grouping === '4'">
      <el-col :span="24">
        <div id="patTypeChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="reasonRow" v-show="grouping === '6'">
      <el-col :span="24">
        <div id="reasonChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="facilityRow" v-show="grouping === '7'">
      <el-col :span="24">
        <div id="facilityChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="dxRow" v-show="grouping === '8'">
      <el-col :span="24">
        <div id="dxChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="sdohRow" v-show="grouping === '18'">
      <el-col :span="24">
        <div id="sdohChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="pxRow" v-show="grouping === '9'">
      <el-col :span="24">
        <div id="pxChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="ccRow" v-show="grouping === '10'">
      <el-col :span="24">
        <div id="ccChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="mccRow" v-show="grouping === '11'">
      <el-col :span="24">
        <div id="mccChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="hacRow" v-show="grouping === '12'">
      <el-col :span="24">
        <div id="hacChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="hccRow" v-show="grouping === '13'">
      <el-col :span="24">
        <div id="hccChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="hccV28Row" v-show="grouping === '17'">
      <el-col :span="24">
        <div id="hccV28Chart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="psiRow" v-show="grouping === '14'">
      <el-col :span="24">
        <div id="psiChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="qmMortalityRow" v-show="grouping === '15'">
      <el-col :span="24">
        <div id="qmMortalityChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="qmReadmissionRow" v-show="grouping === '16'">
      <el-col :span="24">
        <div id="qmReadmissionChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="serviceLineRow" v-show="grouping === '20'">
      <el-col :span="24">
        <div id="serviceLineChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="soiRow" v-show="grouping === '21'">
      <el-col :span="24">
        <div id="soiChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
    <el-row id="romRow" v-show="grouping === '22'">
      <el-col :span="24">
        <div id="romChart" v-show="!noReviewDashboardData" style="min-height: 400px; margin: 0 auto;"></div>
      </el-col>
      <div style="width: 120px; margin: 0 auto; font-size: 12px; color: #909399;" v-if="noReviewDashboardData">No Charts Available</div>
    </el-row>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions } from 'vuex'
import hiaFilters from '@/mixins/hiaFilters'
import debounce from 'debounce'

export default {
  data: function() {
    return {
      highCharts: null,
      noReviewDashboardData: true,
      visibleSeries: []
    }
  },
  name: 'InpatientCharts',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    filterCriteria: { type: String },
    isClosed: { type: Boolean },
    selectedGrouping: { type: Array }
  },
  components: {},
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    getTableData(grouping) {
      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null && this.reviewDashboardData[ipIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        if (this.selectedGrouping.length) {
          let data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []
          let groupKey = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupKey : ''
          return data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }
        return this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []
      }
      return []
    },
    toPercent(value) {
      return value != null && isFinite(value) ? parseFloat((value * 100).toFixed(2)) : 0
    },
    getSeriesData(data, category, divId) {
      let seriesData = []

      if (category === 'changeReason') {
        seriesData.push({ name: 'Total Records', data: data.map(x => x.totalRecords || 0) })
        return seriesData
      }

      if (['soiChart', 'romChart'].includes(divId)) {
        seriesData.push({ name: 'No Change', data: data.map(x => x.noChange || 0) })
        seriesData.push({ name: 'Increases', data: data.map(x => x.increases || 0) })
        seriesData.push({ name: 'Decreases', data: data.map(x => x.decreases || 0) })
        return seriesData
      }

      if (category === 'code' && ['dxChart', 'ccChart', 'mccChart', 'hacChart', 'sdohChart'].some(s => s === divId)) {
        seriesData.push({ name: 'Accuracy Rate', data: data.map(x => this.toPercent(x.cmCodes)) })
        seriesData.push({ name: 'POA Accuracy Rate', data: data.map(x => this.toPercent(x.poaCodes)), visible: false })
        return seriesData
      }

      if (category === 'code' && divId === 'pxChart') {
        seriesData.push({ name: 'Accuracy Rate', data: data.map(x => this.toPercent(x.pcsCodes)) })
        return seriesData
      }

      if (['psiChart', 'qmMortalityChart', 'qmReadmissionChart'].some(s => s === divId)) {
        seriesData.push({ name: 'Accuracy Rate', data: data.map(x => this.toPercent(x.accuracy)) })
        return seriesData
      }

      if (['hccChart'].includes(divId)) {
        seriesData.push({ name: 'Accuracy Rate', data: data.map(x => this.toPercent(x.accuracyRate)) })
        return seriesData
      }

      if (['hccV28Chart'].includes(divId)) {
        seriesData.push({ name: 'Accuracy Rate', data: data.map(x => this.toPercent(x.accuracyRate)) })
        return seriesData
      }

      seriesData.push({ name: 'Total DRGs', data: data.map(x => this.toPercent(x.totalDRGs)) })
      seriesData.push({ name: 'Total DRG w/o Query', data: data.map(x => this.toPercent(x.totalDRGNoQuery)), visible: false })
      seriesData.push({ name: 'Total Codes', data: data.map(x => this.toPercent(x.totalCodes)), visible: false })
      seriesData.push({ name: 'CM Codes', data: data.map(x => this.toPercent(x.cmCodes)), visible: false })
      seriesData.push({ name: 'PCS Codes', data: data.map(x => this.toPercent(x.pcsCodes)), visible: false })
      seriesData.push({ name: 'Patient Status Codes', data: data.map(x => this.toPercent(x.patStatCodes)), visible: false })
      seriesData.push({ name: 'POA Codes', data: data.map(x => this.toPercent(x.poaCodes)), visible: false })
      seriesData.push({ name: 'POO Codes', data: data.map(x => this.toPercent(x.pooCodes)), visible: false })
      return seriesData
    },
    buildBarChart(data, category, divId) {
      if (!this.highCharts) return
      let vm = this
      let seriesData = this.getSeriesData(data, category, divId)
      let categoryData = []
      let floor = 50
      let ceiling = 100
      categoryData = data.map(x => (Number.isInteger(x[category]) ? x[category] : x[category].replace(/>/g, '').replace(/</g, '')))

      if (divId === 'coderTrendingChart') {
        categoryData = data.map(x => (Number.isInteger(x[category]) ? `${x[category]} <br/> ${x.projectName}` : `${x[category].replace(/>/g, '').replace(/</g, '')} <br/> ${x.projectName}`))
      }

      const isCountChart = category === 'changeReason' || divId === 'soiChart' || divId === 'romChart'
      if (isCountChart) {
        floor = 0
        if (divId === 'soiChart' || divId === 'romChart') {
          if (data.length > 0 && seriesData.length >= 3) {
            const sums = data.map((row, i) =>
              (seriesData[0].data[i] || 0) + (seriesData[1].data[i] || 0) + (seriesData[2].data[i] || 0)
            )
            ceiling = Math.max(...sums, 1)
          } else {
            ceiling = 1
          }
        } else if (seriesData.length > 0 && seriesData[0].data.length > 0) {
          ceiling = seriesData[0].data.reduce((t, a) => t + a)
        }
      } else {
        const allValues = seriesData.flatMap(s => s.data)
        const minValue = allValues.length > 0 ? Math.min(...allValues) : 0
        floor = Math.max(0, Math.floor(minValue / 10) * 10)
      }

      // show visible series if exist
      if (this.visibleSeries.length) {
        seriesData.forEach((v, i) => {
          if (this.visibleSeries.some(x => x.name === v.name)) {
            v.visible = true
          }
        })
      }

      // seriesData.push({ name: 'cmCodes', data: [1.1, 2, 3.54, 4, 5, 6, 7, 6, 4, 3, 3] })
      this.highCharts.chart(divId, {
        chart: {
          type: 'bar',
          height: '50%',
          events: {
            render: function() {
              vm.visibleSeries = this.series.filter(x => x.visible)
            }
          }
        },
        accessibility: {
          // description: 'An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.'
        },
        title: {
          // text: ''
          style: { display: 'none' }
        },
        subtitle: {
          // text: 'Sources: <a href="https://thebulletin.org/2006/july/global-nuclear-stockpiles-1945-2006">' +
          //   'thebulletin.org</a> &amp <a href="https://www.armscontrol.org/factsheets/Nuclearweaponswhohaswhat">' +
          //   'armscontrol.org</a>'
        },
        legend: {
          reversed: false,
          verticalAlign: 'top'
        },
        xAxis: {
          reserveSpace: false,
          allowDecimals: true,
          categories: categoryData,
          labels: {
            formatter: function(i) {
              // console.log(i)
              // return (i.pos + 1)
              return this.value
            }
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          ceiling: ceiling,
          floor: floor,
          labels: {
            formatter: function(i) {
              return isCountChart ? `${this.value}` : `${this.value}%`
            }
          }
        },
        tooltip: {
          pointFormat: isCountChart ? '{point.y}' : '{point.y}%'
        },
        plotOptions: {
          series: {
            // stacking: 'normal'
          }
        },
        series: seriesData,
        colors: ['#88B95B', '#005695', '#FFC40C', '#6DCFF6', '#EC008C', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6', '#EC008C', '#6DCFF6', '#FFC40C', '#88B95B', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6', '#EC008C', '#6DCFF6', '#FFC40C', '#88B95B', '#808285', '#58595b', '#005695', '#004776', '#EC008C', '#6DCFF6']
      })
    },
    loadChart() {
      switch (this.grouping) {
        case '1':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.coderTableData, this.filterCriteria) : this.coderTableData, 'coder', 'coderChart')
          break
        case '19':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.coderTrendingTableData, this.filterCriteria) : this.coderTrendingTableData, 'coder', 'coderTrendingChart')
          break
        case '2':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.cdiStaffTableData, this.filterCriteria) : this.cdiStaffTableData, 'cdiStaff', 'cdiStaffChart')
          break
        case '3':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.drgTableData, this.filterCriteria) : this.drgTableData, 'orDrg', 'drgChart')
          break
        case '4':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.patientTypeTableData, this.filterCriteria) : this.patientTypeTableData, 'patTypeDesc', 'patTypeChart')
          break
        case '6':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.reasonTableData, this.filterCriteria) : this.reasonTableData, 'changeReason', 'reasonChart')
          break
        case '7':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.facilityTableData, this.filterCriteria) : this.facilityTableData, 'cliName', 'facilityChart')
          break
        case '8':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.dxTableData, this.filterCriteria) : this.dxTableData, 'code', 'dxChart')
          break
        case '18':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.sdohTableData, this.filterCriteria) : this.sdohTableData, 'code', 'sdohChart')
          break
        case '9':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.pxTableData, this.filterCriteria) : this.pxTableData, 'code', 'pxChart')
          break
        case '10':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.ccTableData, this.filterCriteria) : this.ccTableData, 'code', 'ccChart')
          break
        case '11':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.mccTableData, this.filterCriteria) : this.mccTableData, 'code', 'mccChart')
          break
        case '12':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.hacTableData, this.filterCriteria) : this.hacTableData, 'code', 'hacChart')
          break
        case '13':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.hccTableData, this.filterCriteria) : this.hccTableData, 'code', 'hccChart')
          break
        case '17':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.hccV28TableData, this.filterCriteria) : this.hccV28TableData, 'code', 'hccV28Chart')
          break
        case '14':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.psiTableData, this.filterCriteria) : this.psiTableData, 'shortDescription', 'psiChart')
          break
        case '15':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.qmMortalityTableData, this.filterCriteria) : this.qmMortalityTableData, 'shortDescription', 'qmMortalityChart')
          break
        case '16':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.qmReadmissionTableData, this.filterCriteria) : this.qmReadmissionTableData, 'shortDescription', 'qmReadmissionChart')
          break
        case '20':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.serviceLineTableData, this.filterCriteria) : this.serviceLineTableData, 'clientServiceLineName', 'serviceLineChart')
          break
        case '21':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.soiTableData, this.filterCriteria) : this.soiTableData, 'origValue', 'soiChart')
          break
        case '22':
          this.buildBarChart(this.filterCriteria.length ? this.filterList(this.romTableData, this.filterCriteria) : this.romTableData, 'origValue', 'romChart')
          break
      }
    }
  },
  created: function() {},
  mounted: function() {
    import(/* webpackChunkName: "highcharts" */ 'highcharts').then(({ default: hc }) => {
      this.highCharts = hc
      if (!this.noReviewDashboardData) {
        this.loadChart()
      }
    })
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    cdiStaffTableData() {
      return this.getTableData('By CDI Staff')
    },
    drgTableData() {
      return this.getTableData('By DRGs')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData('By SDOH Dx')
    },
    pxTableData() {
      return this.getTableData('By Px')
    },
    ccTableData() {
      return this.getTableData('By CC')
    },
    mccTableData() {
      return this.getTableData('By MCC')
    },
    hacTableData() {
      return this.getTableData('By HAC')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    psiTableData() {
      return this.getTableData('By PSI')
    },
    qmMortalityTableData() {
      return this.getTableData('By QM Mortality')
    },
    qmReadmissionTableData() {
      return this.getTableData('By QM Readmission')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    },
    soiTableData() {
      return this.getTableData('SOI')
    },
    romTableData() {
      return this.getTableData('ROM')
    }
  },
  watch: {
    reviewDashboardData: {
      handler: function() {
        let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
        if (ipIndex !== null) {
          if (this.reviewDashboardData[ipIndex].largeStats && this.reviewDashboardData[ipIndex].largeStats.length) {
            this.noReviewDashboardData = false
            this.loadChart()
          } else {
            this.noReviewDashboardData = true
          }
        } else {
          this.noReviewDashboardData = true
        }
      },
      deep: true
    },
    grouping() {
      this.visibleSeries = []
      this.loadChart()
    },
    selectedGrouping() {
      this.loadChart()
    },
    filterCriteria: debounce(function() {
      this.loadChart()
    }, 350),
    isClosed() {
      setTimeout(() => {
        this.loadChart()
      }, 200)
    }
  }
}
</script>
